const prefix = '[SubjectAreas]';

export class LoadSubjectAreas {
    static readonly type = `${prefix} Load`;
    constructor(public readonly payload = { pageSize: 20 }) {}
}

export class LoadMoreSubjectAreas {
    static readonly type = `${prefix} Load More`;
}

export class LoadAllSubjectAreas {
    static readonly type = `${prefix} Load All`;
}
